import { render, staticRenderFns } from "./AddBankDeposit.vue?vue&type=template&id=4973aad5"
import script from "./AddBankDeposit.vue?vue&type=script&lang=js"
export * from "./AddBankDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports